import { cn } from "@/styles/utils"
import React, { type PropsWithChildren } from "react"
import { View } from "react-native"
import {
  Tooltip as GluestackTooltip,
  TooltipContent,
  TooltipText,
} from "./gluestack/tooltip"

export type TooltipProps = PropsWithChildren<{
  content: string
  className?: string
  textClassName?: string
  placement?:
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top left"
    | "top right"
    | "bottom left"
    | "bottom right"
    | "left top"
    | "left bottom"
    | "right top"
    | "right bottom"
  openDelay?: number
}>

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  className,
  textClassName,
  placement = "top",
  openDelay = 0,
}) => {
  return content ? (
    <GluestackTooltip
      placement={placement}
      trigger={(triggerProps: any) => <View {...triggerProps}>{children}</View>}
      openDelay={openDelay}
    >
      <TooltipContent
        className={cn("bg-black dark:bg-white rounded-xl", className)}
      >
        <TooltipText
          className={cn("text-white dark:text-black", textClassName)}
        >
          {content}
        </TooltipText>
      </TooltipContent>
    </GluestackTooltip>
  ) : (
    children
  )
}
